const $variantSelects = $('.select select'); // Target all variant dropdowns
const $paymentButton = $('.shopify-payment-button__button');
const $submitButton = $('.product-form__submit');

function addSelectPlaceholders() {
  $variantSelects.each(function () {
    const $select = $(this);
    const optionName = $select.attr('name').match(/\[([^\]]+)\]/)?.[1]; // Extracts "Size", "Color", etc.
    const placeholderValue = `select_${optionName?.toLowerCase() || 'option'}`;
    const placeholderText = `Select ${optionName || 'Option'}`;

    // Add placeholder only if it doesn't exist
    if (!$select.find(`option[value="${placeholderValue}"]`).length) {
      $select.prepend(`<option value="${placeholderValue}" selected>${placeholderText}</option>`);
      $select.find('option').not(`[value="${placeholderValue}"]`).removeAttr('selected');
    }
  });
}

function checkVariantSelections() {
  let disableButtons = false;

  $variantSelects.each(function () {
    const selectedVal = $(this).val();
    if (selectedVal && selectedVal.startsWith('select_')) {
      disableButtons = true;
      return false; // Exit loop early
    }
  });

  $paymentButton.prop('disabled', disableButtons);
  $submitButton.prop('disabled', disableButtons);
}

// Initialize
addSelectPlaceholders();
$variantSelects.on('change', checkVariantSelections);
checkVariantSelections();
